.recipient-count {
    margin-top: 4px;
}
